import { useQuery } from '@tanstack/react-query'
import { llmReasoningApi } from '../api/client'
import { useExpandablePanel } from '../hooks/useExpandablePanel'
import { ExpandToggle } from './ExpandToggle'
import './LLMAuditList.css'

const DECISION_LABEL: Record<string, string> = {
  applied: 'Applied',
  auto_rejected: 'Auto-rejected',
  queued_for_human: 'Queued for review',
}

export function LLMAuditList() {
  const { expanded, toggle, scrollClassName } = useExpandablePanel('llm-audit')
  const q = useQuery({
    queryKey: ['llm-reasoning-history'],
    queryFn: () => llmReasoningApi.history(25),
    refetchInterval: 30000,
  })

  return (
    <div className="card llm-audit-list">
      <div className="panel-head">
        <h3>LLM goal-adjustment audit</h3>
        <ExpandToggle expanded={expanded} onToggle={toggle} />
      </div>
      {q.isLoading && <p className="llm-muted">Loading…</p>}
      {q.isError && <p className="llm-muted">Failed to load audit history.</p>}
      {q.data && q.data.items.length === 0 && (
        <p className="llm-muted">No LLM-driven goal adjustments yet.</p>
      )}
      {q.data && q.data.items.length > 0 && (
        <div className={scrollClassName}><table className="llm-audit-table">
          <thead>
            <tr>
              <th>When</th>
              <th>Goal</th>
              <th>Change</th>
              <th>Decision</th>
              <th>Notes</th>
            </tr>
          </thead>
          <tbody>
            {q.data.items.map((item) => {
              const d = item.output_data
              const decision = d.decision ?? '—'
              const label = DECISION_LABEL[decision] ?? decision
              const change =
                d.current_value !== undefined && d.proposed_value !== undefined
                  ? `${d.current_value} → ${d.proposed_value}`
                  : '—'
              const notes: string[] = []
              if (d.via_precedent !== null && d.via_precedent !== undefined) {
                notes.push(`precedent #${d.via_precedent}`)
              }
              if (d.violation_kind) notes.push(d.violation_kind)
              if (item.backtest_run_id) notes.push(`backtest ${item.backtest_run_id}`)
              return (
                <tr key={item.id}>
                  <td className="llm-audit-when">
                    {item.timestamp
                      ? item.timestamp.replace('T', ' ').slice(0, 19) + ' UTC'
                      : '—'}
                  </td>
                  <td>{d.goal_type ?? '—'}</td>
                  <td className="llm-audit-num">{change}</td>
                  <td>
                    <span className={`llm-audit-badge llm-audit-${decision}`}>
                      {label}
                    </span>
                  </td>
                  <td className="llm-audit-notes">{notes.join(' · ') || '—'}</td>
                </tr>
              )
            })}
          </tbody>
        </table></div>
      )}
    </div>
  )
}
